
import { IonApp, IonRouterOutlet, isPlatform } from '@ionic/vue';
import { defineComponent } from 'vue';
import { ScreenOrientation } from "@awesome-cordova-plugins/screen-orientation";
import { AndroidPermissions } from "@awesome-cordova-plugins/android-permissions";
import { OpenNativeSettings } from "@awesome-cordova-plugins/open-native-settings";
import common from "@/common";
import { StatusBar } from "@capacitor/status-bar";
import $ from 'jquery';
import { Diagnostic } from "@awesome-cordova-plugins/diagnostic";
import { Media } from "@awesome-cordova-plugins/media";
import { Device } from '@capacitor/device';
import OrientationOverlay from "@/components/common/OrientationOverlay.vue";
import audioPreloader from "@/utils/audioPreloader";

export default defineComponent({
  name: 'App',
  components: {
    IonApp,
    IonRouterOutlet,
    OrientationOverlay
  },
  data() {
    return {
      show_input: 'hide-input',
      input_height: '',
    }
  },
  computed: {
    showDebugBadge: function () {
      return common.config.debug === true && !isPlatform('hybrid');
    },
  },
  mounted: function () {
    // 预加载所有音频文件，延迟执行避开渲染高峰
    setTimeout(() => {
      audioPreloader.preloadAll();
    }, 2000);

    // todo 从别的设备登录看测试结果

    // todo 为了安全，服务器接口添加一串秘钥

    let platform = 0;
    let version = '';

    // 判断是否在移动设备上运行
    if (isPlatform('mobile') || isPlatform('tablet')) {
      platform = 1;
      version = common.config.android_version;

      // 横屏

      if (isPlatform('hybrid')) {
        ScreenOrientation.lock(ScreenOrientation.ORIENTATIONS.LANDSCAPE);
      }

      if (isPlatform('hybrid') && isPlatform('android')) {
        // 设置为全屏，即不显示手机上面的状态栏
        StatusBar.hide()

        this.getAndroidSDKVersion();

      } else if (isPlatform('hybrid') && isPlatform('ios')) {
        platform = 2;
        version = common.config.ios_version;

        Diagnostic.getMicrophoneAuthorizationStatus().then(status => {
          if (status == 'not_determined') {
            // 首次进入
            const media = Media.create('test.wav');
            media.startRecord();
            media.stopRecord();

            const inter = setInterval(function () {
              Diagnostic.getMicrophoneAuthorizationStatus().then(status_2 => {
                if (status_2 != 'not_determined') {
                  clearInterval(inter)
                }
                if (status_2 == 'denied_always') {
                  common.showAlert('基於研究需要，測試途中需要進行錄音，請前往設定頁開啓麥克風存取權限。', '允許麥克風存取權限', function () {
                    OpenNativeSettings.open('application_details')
                  }, '前往設定頁')
                }
              })
            }, 100)
          } else if (status == 'denied_always') {
            common.showAlert('基於研究需要，測試途中需要進行錄音，請前往設定頁開啓麥克風存取權限。', '允許麥克風存取權限', function () {
              OpenNativeSettings.open('application_details')
            }, '前往設定頁')
          }
        })

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;

        // 禁止页面滚动，橡皮筋效果
        window.document.body.addEventListener('touchstart', function (e) {
          const target = that.getTarget(e);
          if (!target || target.clientHeight == target.scrollHeight) {
            return;
          }

          if (target.scrollTop == 0) {
            target.scrollBy(0, 1)
          } else if (target.scrollTop + target.clientHeight == target.scrollHeight) {
            target.scrollBy(0, -1)
          }

        }, { passive: false })

        window.document.body.addEventListener('touchmove', function (e) {
          const target = that.getTarget(e);
          if (!target || target.clientHeight == target.scrollHeight) {
            e.preventDefault();
          } else {
            return true;
          }

        }, { passive: false })
      }

      // 檢查about是否有更新
      common.getStorage('about_version').then(version => {
        if (!version) {
          this.getAbout()
        } else {
          common.apiGetData('/aboutVersion').then(res => {
            if (res === false) {
              return false;
            }
            if (res.version != version) {
              this.getAbout();
            }
          })
        }
      })
    }

  },

  methods: {
    // 獲取安卓版本号
    async getAndroidSDKVersion () {
      const androidSDKVersion = (await Device.getInfo()).androidSDKVersion;
      if (androidSDKVersion) {
        if (androidSDKVersion <= 32) {
          this.checkAndroidPermissions(AndroidPermissions.PERMISSION.RECORD_AUDIO, AndroidPermissions.PERMISSION.READ_EXTERNAL_STORAGE, AndroidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE);
        }
        else {
          this.checkAndroidPermissions(AndroidPermissions.PERMISSION.RECORD_AUDIO);
        }
      }
    },

    // 安卓授權
    checkAndroidPermissions: function (...permissions: string[]) {
      AndroidPermissions.requestPermissions(permissions).then(res => {
        if (!res.hasPermission) {
          common.showAlert('基於研究需要，測試途中需要進行錄音，請前往設定頁開啓麥克風存取權限。', '允許麥克風存取權限', function () {
            OpenNativeSettings.open('application_details');
          }, '前往設定頁')
        }
      })
    },
    getAbout: function () {
      common.apiGetData('/about').then(res => {
        if (res === false) {
          return false;
        }

        common.setStorage('about_version', res.version);
        common.setStorage('about_data', res.data);
      })
    },

    getTarget: function (ele: any) {
      const target = ele.target as HTMLTextAreaElement;

      if ($($(target)[0]).hasClass('enable-scroll')) {
        return target;
      } else if ($(target).parents('.enable-scroll').length) {
        return $(target).parents('.enable-scroll')[0];
      } else {
        return false;
      }
    },
  }
});
